import { ValidationErrorMessage } from 'components/Forms'
import { Form } from 'react-bootstrap'
import styled from 'styled-components'

export const MyProfileStyled = styled.div`
  background-color: ${({ theme }) => theme.colors.backgroundText};
  margin-left: 2.4rem;
  margin-right: 2.4rem;
  margin-bottom: 2.4rem;
  flex: 1;

  .add-icon {
    font-size: 2rem;
  }

  input::-ms-reveal,
  input::-ms-clear {
    display: none;
  }

  .save-button {
    display: flex;
    flex-direction: row-reverse;
  }

  .additional-noti {
    border-bottom: 1px solid #ccc;
    margin-bottom: 1.5rem;
  }

  .text-right {
    justify-content: end;
    padding-right: 0.5rem;
  }

  .form-group,
  .form-text {
    width: 100%;
    padding-left: 2rem;
  }

  .question-error-messages {
    padding-left: 0;
  }

  .label {
    padding-top: 1rem;
    padding-right: 0.5rem;
  }

  .input-field {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 0.5rem;
  }

  .form-control {
    border-radius: 0.25rem !important;
    height: calc(1.5em + 0.75rem + 0.2rem);
    padding: 0.375rem 0.75rem;
  }

  .submit-button {
    width: 12rem;
  }
`

export const MyProfileBody = styled.div`
  width: 60%;
  margin: auto;
  background-color: white;
`

export const Title = styled.h2`
  color: ${({ theme }) => theme.colors.primary};
  font-size: 3rem;
  margin-bottom: 1.2rem;
`

export const SectionTitle = styled.div`
  color: ${({ theme }) => theme.colors.primary};
  font-size: 2rem;
  margin-top: 1rem;
  margin-bottom: 3rem;
  border-bottom: 1px solid #ccc;
`

export const ProfileSection = styled.div`
  margin: auto;
  margin-bottom: 3rem;
  .custom-select {
    background: none;
  }

  .custom-select-lg {
    height: calc(1.5em + 0.75rem + 0.2rem);
    padding: 0.375rem 0.75rem;
    font-size: 1.3rem;
  }
`

export const GroupButtonStyled = styled(Form.Group)`
  display: flex;
  justify-content: end;
`

export const PasswordInputStyled = styled(Form.Control)``

export const PasswordEye = styled.i`
  padding-right: 0.5rem;
  padding-left: 0.5rem;
  position: absolute;
  align-self: center;
  right: 0;
  z-index: 5;
`

export const MyProfileValidationErrorMessage = styled(ValidationErrorMessage)`
  padding-left: 0 !important;
`
